import { sortObjectListByKey } from 'utils/arrayHelpers';
import { combineByValue } from './combineByValue';
import { MeterOptions } from '../types';

/**
 *
 * we need to massage the data so that it is sorted and reconstructed so there's always 6 elements total.
 * In order to accomplish this any data sets surpassing 6 elements will be reformatted into an "Other" object with the totalled value
 * of the remaining values.
 */
export const formatHighestByValueAndSorts = (meterOptions: MeterOptions[]): MeterOptions[] => {
  const sortedBarData = sortObjectListByKey(meterOptions, 'value').sort(
    (a, b) => b.value - a.value,
  );
  if (meterOptions.length <= 6) {
    return sortedBarData;
  } else {
    const remainingOtherData = combineByValue(sortedBarData.slice(5));
    return [...sortedBarData.slice(0, 5), remainingOtherData];
  }
};
